import { render, staticRenderFns } from "./TutorModal.vue?vue&type=template&id=5a014ae4&scoped=true&"
import script from "./TutorModal.vue?vue&type=script&lang=js&"
export * from "./TutorModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorModal.scss?vue&type=style&index=0&id=5a014ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a014ae4",
  null
  
)

export default component.exports